<!-- 组件说明 -->
<template>
  <div class="order_step">
    <van-collapse v-model="activeNames" class>
     
      <van-collapse-item :title="$t('order3.Total')+totalPrice(orderGoods)"  name="1">
        <div v-for="item in orderGoods" :key="item.id" :name="item">
          <van-card
            :title="item.prodName"
            :desc="item.desc"
            :num="item.num"
            :price="formatPrice(item.selectedSkuPrice)"
            :thumb="item.pic"
          >
            <div slot="bottom">
              <div class="sku">{{item.selectedSkuName}}</div>
            </div>
          </van-card>
        </div>
        <div>
          <div class="order_item">
            <span>{{$t('detail.Subtotal')}}:</span>
            <span>{{$t('Pay.money')}}{{totalPrice(orderGoods)}}</span>
          </div>
          <div :class="['order_item','top']">
            <span>{{$t('detail.carriage')}}:</span>
            <span>{{$t('Pay.money')}}0</span>
          </div>
          <van-divider></van-divider>
          <div :class="['order_item']">
            <span>{{$t('detail.Total')}}({{orderGoods.length}}){{$t('detail.jian')}}</span>
            <span>{{$t('Pay.money')}} {{totalPrice(orderGoods)}}</span>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <!--
    <container class="top" title="顧客資料">
      <div :class="[]">
        <span>顧客名稱</span>
        <van-field v-model="nameValue" class="field" />
      </div>
      <div :class="[,'top']">
        <span>電子信箱</span>
        <van-field v-model="emailValue" class="field" />
      </div>
      <div :class="[,'top']">
        <span>電話號碼</span>
        <van-field v-model="phoneValue" class="field" />
      </div>
    </container>-->
     <!-- <container class="top" title="选择送货及付款方式">
      <div>
        <div class="item_name">送货地点</div>
        <div class="item_value" @click="locationPop = true">
          <span>台灣</span>
          <van-icon name="arrow-down" />
        </div>
        <div :class="['item_name','top']">送貨方式</div>
        <div class="item_value" @click="sendPop = true">
          <span>{{getSendName(sendValue)}}</span>
          <van-icon name="arrow-down" />
        </div>
      </div>
    </container> -->
    <container class="top" :title="$t('order3.Delivery_information')" :desc="$t('order3.freight')">
     <!-- <van-checkbox v-model="sameUser" :style="{marginTop:'0.12rem'}">收件人資料與顧客資料相同</van-checkbox>-->
      <div>{{$t('detail.Delivery_method')}}</div>
      <div class="item_value" @click="isValus()">
        <!-- <span>{{area1=='台灣'?getSendName(getValue):'貨到付款'}}</span> -->
        <span>{{area1=='台灣'?getSendName(getValue):$t("Pay.language")}}</span>
        <van-icon name="arrow-down" />
      </div>
      <div :class="['top']">
        <span>{{$t('data.Recipient_name')}}</span>
        <van-field @input="input" v-model="arrNameValue" class="field"/>
        <div>{{$t('data.Recipient_nameTips')}}</div>
      </div>
      <div :class="[,'top']">
        <span>{{$t('order.phone')}}</span>
        <van-field @input="input" v-model="arrPhoneValue" class="field"/>
      </div>
      <div :class="[,'top']">
        <span>{{$t('data.email')}}</span>
        <van-field v-model="emailValue" class="field" />
      </div>
      <van-divider></van-divider>
      <div class="selected_wrapper" v-if="getValue=='1'||getValue=='2'">
        <van-image v-if="getValue=='1'" :src="iconf" class="icon_size" />
        <van-image v-if="getValue=='2'" :src="icon7" class="icon_size" />
        <div class="selected_market">{{$t('data.Select_M')}}</div>
      </div>
      <div :style="{marginTop:'0.12rem'}" v-if="address.cvsspot">
        <div>{{$t('data.Select_M_number')}}:</div>
        <div>{{address.cvsspot}}</div>
        <div>{{$t('data.Selected_store_name')}}:</div>
        <div>{{address.name}}</div>
        <div>{{$t('data.Shop_address')}}:</div>
        <div>{{address.addr}}</div>
      </div>
      <van-button
        type="primary"
        size="small"
        :class="['small_btn','top']"
        @click="selectMarket"
        v-if="getValue=='1'||getValue=='2'"
      >{{address.cvsspot? $t('order3.change'): $t('order3.Search_shop')}}</van-button>
       <div class="address" v-if="getValue=='3'">
          <span>{{$t('order3.Select_address')}}</span>
          <div class="item_value" @click="areaPops = true">
            <span>{{area1}}</span>
            <!-- <van-icon name="arrow-down" /> -->
          </div>
          <div class="item_value" @click="getArea2Pop">
            <span>{{getArea2Name(area2,1)||'請選擇'}}</span>
            <van-icon name="arrow-down" />
          </div>
          <div class="item_value" @click="getArea3Pop()" v-if="isShow">
            <span>{{getArea2Name(area3,2)||'請選擇'}}</span>
            <van-icon name="arrow-down" />
          </div>
          <div>
            <van-field v-model="areaAddress" class="field" :placeholder="$t('order3.xxdz')"/>
          </div>
       </div>
       
    </container>
    <container class="top" :title="$t('order3.Order_notes')">
      <van-field class="textarea" v-model="remarkValue" type="textarea" :placeholder="$t('order3.Tell_the_seller')" />
    </container>
    <container class="top" :title="$t('order3.Payment_information')">
      <div>{{$t('order3.Payment_method_selected')}}: {{getSendName(getValue)}}</div>
      <van-button type="primary" class="top" size="large" @click="sumbit">{{$t('order3.Submit_order')}}</van-button>
    </container>

     <van-popup v-model="locationPop" class="pop">
      <van-radio-group v-model="locationValue">
        <van-radio class="radio_item" name="1">{{$t('newOrder.tw')}}</van-radio>
      </van-radio-group>
    </van-popup>

     <van-popup v-model="sendPop" class="pop">
      <van-radio-group v-model="getValue">
        <van-radio
          v-for="(item,index) in sendItems"
          :key="index"
          class="radio_item"
          :name="item.id"
          @click="changePay(item.id)"
        >{{item.name}}</van-radio>
      </van-radio-group>
    </van-popup>
    <!-- <van-popup v-model="payPop" class="pop">
      <van-radio-group v-model="getValue">
        <van-radio
          v-for="(item,index) in getItems"
          :key="index"
          class="radio_item"
          :name="item.id"
        >{{item.name}}</van-radio>
      </van-radio-group>
    </van-popup> -->    
    <van-popup v-model="areaPop" class="pop">
      <van-radio-group v-model="area2">
        <van-radio
          v-for="(item,index) in area2List"
          :key="index"
          class="radio_item"
          :name="item.areaId"
          @click="areaPop=false"
        >{{item.areaName}}</van-radio>
      </van-radio-group>
    </van-popup>

    <van-popup v-model="area3Pop" class="pop">
      <van-radio-group v-model="area3">
        <van-radio
          v-for="(item,index) in area3List"
          :key="index"
          class="radio_item"
          :name="item.areaId"
          @click="area3Pop=false"
        >{{item.areaName}}</van-radio>
      </van-radio-group>
    </van-popup>
  </div>
</template>

<script>
import Container from '@/components/container';
import { Toast } from 'vant';
import { mapMutations, mapState } from 'vuex';
import { getQueryVariable, uuid } from '@/utils/index';
import goods from '@/api/goods';
import home from '@/api/home';
import { moneys } from "../../static/moneyString"
import {
    HOST,DEV
} from '@/utils/const'
export default {
  components: { Container },
  data() {
    return {
      moneysString:'',
      isShow:true,
      activeNames: [],
      sameUser: true,
      nameValue: '',
      emailValue: '',
      phoneValue: '',
      arrNameValue: '',
      arrPhoneValue: '',
      remarkValue: '',
      address: {},
      errorInfo: {
        nameValue: false,
        emailValue: false,
        phoneValue: false,
        arrNameValue: false,
        arrPhoneValue: false,
      },
      sendItems: [
        {
          id: '1',
          name: '全家 取貨付款',
        },
        {
          id: '2',
          name: '7-11 取貨付款',
        },
        {
          id: '3',
          name: '黑貓宅配',
        },
      ],
      getItems: [
        {
          id: '1',
          name: '全家 取貨付款',
        },
        {
          id: '2',
          name: '7-11 取貨付款',
        },
      ],
      getValue: '1',
      iconf:require('../assets/family_mart.jpg'),
      icon7:require('../assets/7_11.png'),
      locationPop: false,
      sendPop: false,
      payPop: false,
      areaPop:false,
      areaPops:false,
      area3Pop: false,
      locationValue: '1',
      sendValue: '1',
      area1:'',
      area2:'',//黑貓宅配的市
      area3:'',//黑貓宅配的区
      areaAddress:'',
      area1List:[],//国家
      area2List:[],//台灣地址市列表
      area3List:[],//台灣地址区列表
      areaCode:'',//区号
      pid:''
    };
  },
  watch: {
    sameUser(newV, oldV) {
      // if (newV) {
      //   this.arrNameValue = this.nameValue;
      //   this.arrPhoneValue = this.phoneValue;
      // }
    },
    nameValue(newV, oldV) {
      // if (this.sameUser) {
      //   this.arrNameValue = newV;
      // }
    },
    phoneValue(newV, oldV) {
      // if (this.sameUser) {
      //   this.arrPhoneValue = newV;
      // }
    },
    
  },
  computed: {
    orderGoods: {
      get() {
        return this.$store.state.goods.orderGoods;
      },
      set(val) {},
    },
  },
  methods: {
    isValus(){
        if(this.area1!='台灣'){
            this.sendPop=false
        }else{
            this.sendPop=true
        }
    },
    changePay(id){  //选择付款方式
      if(this.getValue==id){
        this.address ={}
      }
      this.getValue = id;
      this.sendPop = false
      
    },
    getcountry(){
        let url = location.host;
        home.region(url).then((res) => {
          // console.log('1111111111111111111111111111',res)
          var dz = res.region
          // console.log('res.res.resa0000000000000000000000',res) 
          // for(var key in res.areaCode){
          //   if(key==res.region){
          //     this.areaCode =res.areaCode[key]
          //   }
          // }
          this.areaCode = res.areaCode
          this.area1=res.region
          this.pid=res.region
          this.listByPid(res.id,1)
          if(res.region !='台灣'){
           this.getValue = '3'
          }
          if(res.region =='日本'){
            this.isShow=false
          }
        })
    },
    getArea2Pop(){
        this.areaPop  =true
        this.area3=''
    },
    listByPid(pid,index){
      // console.log('pid',pid)
        let param = {pid:pid}
        goods.listByPid(param).then((res) => {
          if(index == 1){
             this.area2List  = res
          }else{
             this.area3List  = res
          }
           
        });
    },
    getArea2Name(id,index){
        let name;
        let List;
        if(index==1){
            List =  this.area2List
        }else{
            List = this.area3List
        }
          List.forEach(item=>{
          if(item.areaId==id){
              name = item.areaName
          }
        })
        return name
    },
    getArea3Pop(){
      this.area3Pop  =true
      this.listByPid(this.area2)
    },
    totalPrice(goods) {
      if(goods[0].selectedProdName){   //套餐的价格
        return goods[0].allPrice * goods[0].num
      }
      return goods.reduce((total, item) => total + item.selectedSkuPrice * item.num, 0);
    },
    ...mapMutations('goods', {
      removeShopCardGoods: 'removeShopCardGoods',
      refreshOrderGoods: 'refreshOrderGoods',
    }),
    getSendName(id) {
        // if(this.area1!='台灣'){
        //     this.getValue=3;
        //     return '貨到付款'
        // }else{
            return this.sendItems[Number(id) - 1].name;
        // }
    },
    getGetItem(id) {
      return this.getItems[Number(id) - 1].name;
    },
    selectMarket(e) {

      sessionStorage.setItem("MarketStatus", 'start');   //解决微信去除#后面参数的问题
      this.$session.set(
        'infos',
        JSON.stringify({
          sameUser: this.sameUser,
          nameValue: this.nameValue,
          emailValue: this.emailValue,
          phoneValue: this.phoneValue,
          arrNameValue: this.arrNameValue,
          arrPhoneValue: this.arrPhoneValue,
          activeNames: this.activeNames,
          remarkValue:this.remarkValue,
        }),
      );
      this.storeOrder();
      let host = DEV;
      // let host = 'http://xiquekj.f3322.net:4041';
      // let host = 'http://31h370424s.zicp.vip';
      // let host = 'http://192.168.1.100:8081';
      if (this.getValue == '1') {  //选择全家地址
        window.location.href = `https://mfme.map.com.tw/default.aspx?cvsname=familymart.shoplineapp.com&cvsid=11111111&cvstemp=${host}api/famil&exchange=true`;
      } else {   //选择七天地址
        // window.location.href = `https://emap.presco.com.tw/c2cemap.ashx?url=${host}/h5/api/eleven?isSameTab=true`;  //PC站
        let uuids = uuid();
        this.$session.set('uuid', uuids);
        let url = `https://emap.presco.com.tw/c2cemapm-u.ashx?url=${host}api/eleven/${uuids}`;
        window.location.href = url; //手机站
      }
    },

    storeOrder() {
      this.$session.set('orders', JSON.stringify(this.orderGoods));
    },
    reStoreOrder() {
      if(this.$session.get('orders')){
          this.refreshOrderGoods(JSON.parse(this.$session.get('orders')));
      }

    },
    sumbit(e) {
      // var items = ['nameValue', 'emailValue', 'phoneValue', 'arrNameValue', 'arrPhoneValue'];
      let addressStatus = false;
      var items = ['arrNameValue', 'arrPhoneValue'];
      var isValid = items.every((item) => {
        var msg = this.getErrorMessage(item);
        if (msg) {
          this.errorInfo[item] = true;
          Toast(msg);
        }
        return !msg;
      });
      if (!isValid) {
        return;
      }
      let orderItems=[]   //订单的産品列表
      this.orderGoods.forEach(function(item,index) {
           orderItems.push({ prodId: item.prodId,  shopId: item.shopId, prodCount: item.num,skuId: item.selectedSkuId });
      });
      let area1;
      let area2;
      let area3;
      let areaAddress;
      if(this.getValue=='3'){
          area1 = this.area1;
          area2 = this.getArea2Name(this.area2,1);
          area3 = this.getArea2Name(this.area3,2);
          areaAddress =  this.areaAddress
          if(area2=='請選擇'||area3=='請選擇'||areaAddress==''){
            addressStatus = true
          }
      }else if(!this.address.addr){
        addressStatus = true
      }
      if(addressStatus){
        Toast('請選擇地址');
        return false
      }
      let sysUserId = this.$session.get("sysUserId")?this.$session.get("sysUserId"):' ';
      let r = /^\+?[1-9][0-9]*$/;　　//正整数 
      let sysUserIdStatus =r.test(sysUserId)
      if(!sysUserIdStatus){
        sysUserId = ""
      }
      // console.log('sysUserId',sysUserId)
      let addrWay
      if(this.getValue=="1"){
         addrWay = '全家';
      }else if(this.getValue=="2"){
        addrWay = '7-11';
      }else{
         addrWay = '黑貓宅配';
      }
      
      let param = {
          // prodCount: this.orderGoods.length,  //産品數量
          // prodId: this.orderGoods[0].prodId,  //産品ID
          urlSource:window.location.href,
          shopId: this.orderGoods[0].shopId,  //店铺ID
          // skuId: this.orderGoods[0].selectedSkuId,  //skuID
          orderItems:orderItems,
          eMail: this.emailValue,                //邮箱号码
          customerName: this.arrNameValue,       //收件人姓名
          telephoneNumber: this.arrPhoneValue,   //收件人手机号码
          remarkValue:this.remarkValue,  //订单备注
          addr: this.address.addr,  //地址信息--详细地址
          cvsspot: this.address.cvsspot,  //地址信息--店铺店名
          name: this.address.name,  //地址信息--店铺店号
          dvyType:  this.getSendName(this.sendValue),//配送类型
          prodName:this.orderGoods[0].selectedProdName, //套餐的套餐Id
          comboOnId:this.orderGoods[0].selectedProdId, //套餐产品上级ID
          //黑貓宅配中的地址--三联地址
          area1:area1,  //台灣
          area2:area2,  //市
          area3:area3,   //区
          address:areaAddress,  //详细地址
          sysUserId:sysUserId,  //userId
          addrWay:addrWay, //选中的地址的类型--如7-11、全家、黑猫
          areaCode:this.areaCode,
          region:this.area1,
          orderSource:this.$session.get("orderSource")?this.$session.get("orderSource"):' ',
          

        // // addrId: '0',  
        // // basketIds: [],  //购物车ID
        // // couponIds: [],  //优惠券ID
        // orderItem: {
        //   // distributionCardNo: '',   
        //   prodCount: this.orderGoods.length,  //産品數量
        //   prodId: this.orderGoods[0].prodId,  //産品ID
        //   shopId: this.orderGoods[0].shopId,  //店铺ID
        //   skuId: this.orderGoods[0].selectedSkuId,  //skuID
        // },
        // // userChangeCoupon: '0',  //用户选择的====adderess= 优惠券
        // userInfo:{                        
        //     eMail: this.emailValue,                //邮箱号码
        //     customerName: this.arrNameValue,       //收件人姓名
        //     telephoneNumber: this.arrPhoneValue,   //收件人手机号码
        // },
        // remarkValue:this.remarkValue,  //订单备注
        // address: this.address,  //地址信息

      };
      
     
      // console.log('=======param======', JSON.stringify(param));
      goods.orderConfirm(JSON.stringify(param)).then((res) => {
        this.$session.set('sysUserId','');
        let ids = [];
        this.orderGoods.forEach((element) => {
          ids.push({ prodId: element.prodId, selectedSkuId: element.selectedSkuId });
        });
        this.removeShopCardGoods(ids);
        if(res){
            this.$router.replace('success');
        }
      
      
        
      });
    },
    input(e) {
      this.sameUser = false;
    },
    formatPrice(price) {
      return price;
    },
    
    isMobile(value) {
      //台灣手机号
      return  /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/.test(value);
    },
    email(value) {
      return /@+/.test(value);
    },
    getErrorMessage(key) {
      var value = String(this._data[key] || '').trim();
      switch (key) {
        // case 'nameValue':
        //   return value ? '' : '顧客名稱 是必須的';
        // case 'emailValue':
        //   return this.email(value) ? '' : '顧客電郵 是必須的';

        // case 'phoneValue':
        //   return this.isMobile(value) ? '' : '顧客電話號碼 是必須的';

        case 'arrNameValue':
          return value ? '' : '收件人名稱 是必須的';

        case 'arrPhoneValue':
          return this.isMobile(value) ? '' : '收件人電話號碼 是必須的';
        // case 'emailValue':
        //   return this.email(value) ? '' : '電子郵箱 是必須的';
      }
    },
    dyRop(dyRop){  //抖音的像素
      var ta = document.createElement('script'); 
      ta.type = 'text/javascript'; ta.async = true;
      ta.src = 'https://analytics.tiktok.com/i18n/pixel/sdk.js?sdkid='+dyRop;
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(ta, s);
    }

  },
  created() {
    var str=this.$session.get('moneyString');
    this.moneysString=moneys[str];
    let shopIds = sessionStorage.getItem("shopId") || this.$store.state.user.regionData.shopId;
    this.$Fbq.getFbqId('cart',shopIds) //fbq像素
    this.dyRop(sessionStorage.getItem('dyRop'))
    // console.log("session",sessionStorage.getItem('dyRop'));
    this.getcountry()
    // this.listByPid(id)  //黑猫宅配的地址
    //生命周期 - 创建完成
    // console.log('elenve', JSON.parse(this.$session.get('elenve') || '{}'));
    let infos = JSON.parse(this.$session.get('infos') || '{}');
    this.sameUser = infos.sameUser || true;
    this.nameValue = infos.nameValue;
    this.emailValue = infos.emailValue;
    this.phoneValue = infos.phoneValue;
    this.arrNameValue = infos.arrNameValue;
    this.arrPhoneValue = infos.arrPhoneValue;
    this.remarkValue =infos.remarkValue;
    this.activeNames = infos.activeNames || [];
    this.$session.set('infos', '');
    let order = JSON.parse(this.$session.get('order') || '{}');
    this.getValue = order.getValue || '1';

/*****原本的七天逻辑*******/
    // if (window.location.href.indexOf('addr') != -1) {
    //   this.reStoreOrder();
    //   let spilt = window.location.href.split('?');
    //   if (spilt.length <= 1) {
    //     return;
    //   }
    //   // let object =  getQueryVariable(spilt[1], )
    //   let addr = decodeURIComponent(getQueryVariable(spilt[1], 'addr'));
    //   let cvsspot = decodeURIComponent(getQueryVariable(spilt[1], 'cvsspot'));
    //   let name = decodeURIComponent(getQueryVariable(spilt[1], 'name'));
    //   this.address = {
    //     addr,
    //     cvsspot,
    //     name,
    //   };
    //   this.getValue = '1';
    //   window.scrollTo(0, 400);
    // }





/*****全家*******/ 
 if (window.location.href.indexOf('uuid') != -1) {
      let spilt = window.location.href.split('?');
      let lastUUIDF = getQueryVariable(spilt[1], 'uuid')
      // let lastUUIDF = this.$session.get('uuidF', '');
      // console.log('====lastUUIDF=', lastUUIDF);
      if (lastUUIDF != '') {
      this.reStoreOrder();
      this.getValue = '1';
      goods.getFamilAddress(lastUUIDF).then((res) => {
        // console.log('====res=', res);
        this.address = {
          addr: res.addr,
          cvsspot: res.cvsspot,
          name: res.name,
        };
      });
    }
 }else{
    /*****七天*******/
    let lastUUID = this.$session.get('uuid', '');
    // console.log('====lastUUID=', lastUUID);

    if (lastUUID != '') {
      this.reStoreOrder();
      this.getValue = '2';
      goods.getAddress(lastUUID).then((res) => {
        // console.log('====res=', res);
        this.address = {
          addr: res.storeaddress,
          cvsspot: res.storeid,
          name: res.storename,
        };
        this.$session.set('uuid', '');
      });
    }
    
 }
 


   
    

    // if (this.getValue == '1') {
    //   this.icon = require('../assets/family_mart.jpg');
    // }
    this.$session.set('order', '');

   
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.order_step {
  padding: 0.8rem;
  box-sizing: border-box;
  .van-collapse {
    border: 1px #ddd solid;
    .van-card {
      background: #fff;
    }
  }
  .field {
    margin-top: 0.24rem;
    border: 1px #ddd solid;
    border-radius: 0.12rem;
  }
  .selected_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    .selected_market {
      margin-left: 0.8rem;
    }
  }
  .small_btn {
    width: 100%;
  }
  .icon_size {
    width: 1.2rem;
    height: 1.2rem;
  }
}
.item_value {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0.6rem;
  margin-top: 0.08rem;
  height: 1.2rem;
  border-radius: 0.12rem;
  justify-content: space-between;
  border: 1px #ddd solid;
}
.top {
  margin-top: 0.88rem;
}
.pop {
  width: 10rem;
  border-radius: 0.12rem;
  padding: 0.4rem 0.8rem 1.2rem 0.8rem;
  .radio_item {
    margin-top: 0.8rem;
  }
}
.order_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.textarea {
  border: 1px #ddd solid;
  border-radius: 0.12rem;
}
.address{
  .item_value{
    margin: 0.3rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderStep3.vue